<template>
	<v-sheet elevation="0">
		<FunctionTitle title="" />
		<CommonFlame :title="title">
			<div class="pa-2">
				<div class="font-weight-bold text-body-1">見積種類を選択</div>
				<v-radio-group v-model="quotationType" row hide-details="">
					<v-radio @click="changeFormType" label="受注製品から選択" value="ordered"></v-radio>
					<v-radio @click="changeFormType" label="未受注製品から選択" value="yet"></v-radio>
				</v-radio-group>
			</div>
			<!-- ここから受注製品 -->
			<template v-if="quotationType == 'ordered'">
				<v-form class="pa-2" ref="form1">
					<v-row no-gutters>
						<v-col cols="12" sm="6">
							<v-select
								v-model="selectedSuppliers"
								label="見積依頼先(必須)"
								:items="suppliers"
								class="mt-2"
								item-text="name"
								item-value="value"
								dense
								outlined
								multiple
								return-object
								hide-details="auto"
								small-chips
								@change="setOrderedMailContent"
							/>
						</v-col>
					</v-row>

					<div class="search-area">
						<v-text-field
							:ref="`ordered_product_text_field`"
							v-model="orderedProduct"
							class="mt-4"
							:hint="orderedProductHint"
							:persistent-hint="!!selectedOrderedProduct"
							label="製品検索(必須)"
							outlined
							dense
							:disabled="selectedSuppliers.length == 0 || !!selectedOrderedProduct"
							:class="{ 'custom-disabled-text-color': !!selectedOrderedProduct }"
							:readonly="!!selectedOrderedProduct"
							@keyup="setSearchOrderedProduct($event)"
						>
							<template v-if="selectedOrderedProduct" v-slot:append>
								<v-btn @click="removeCard()" icon small>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-text-field>

						<OrderedProductSearchResult
							v-if="orderedProductResultFlag"
							:ordered_products="ordered_products"
							:options="options"
							@set="setOrderedProduct($event)"
						/>

						<v-row no-gutters>
							<v-col cols="12" sm="6">
								<v-row no-gutters class="flex-nowrap">
									<v-select
										v-model="orderComponentArray"
										label="部品選択(必須)"
										:items="orderComponents"
										class="mt-2 mr-1"
										item-text="component.name"
										item-value="id"
										multiple
										dense
										outlined
										return-object
										:disabled="orderComponents.length == 0"
										:hint="
											!!selectedOrderedProduct
												? '選択後に右の＋ボタンを押してください'
												: '製品を先に選択してください'
										"
										:persistent-hint="!(!orderComponentArray.length && quantityFields.length)"
										no-data-text="データがありません"
									/>
									<v-btn
										:disabled="orderComponentArray.length == 0"
										@click="setOrderComponent"
										class="mt-2"
										dense
										outlined
										color="secondary"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
								</v-row>
							</v-col>
						</v-row>

						<div class="quantity-field-area">
							<v-row
								no-gutters
								class="top-divider"
								v-for="(field, index) in quantityFields"
								align="center"
								:key="`quantity-field-${index}`"
							>
								<v-col cols="12" sm="6">
									<v-row no-gutters>
										<v-col cols="12" sm="1">
											<v-row no-gutters justify="space-between">
												{{ `${index + 1}.` }}
												<v-row v-if="$vuetify.breakpoint.xs" no-gutters justify="end">
													<v-btn
														@click="removeQuantityField(field.value, index)"
														icon
														color="red"
														class="mt-0"
														><v-icon>mdi-close-circle-outline</v-icon></v-btn
													>
												</v-row>
											</v-row>
										</v-col>
										<v-col cols="12" sm="11">
											<p v-if="field.value.component" class="pb-4">
												部品名：{{ field.value.component.name }}　　品番：{{
													field.value.component.part_number
												}}
											</p>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="field.value.quantity"
										class="mt-2 append-outer"
										label="数量(必須)"
										outlined
										dense
									>
										<template v-if="!$vuetify.breakpoint.xs" v-slot:append-outer>
											<v-btn
												@click="removeQuantityField(field.value, index)"
												icon
												color="red"
												class="mt-0"
												><v-icon>mdi-close-circle-outline</v-icon></v-btn
											>
										</template>
									</v-text-field>
								</v-col>
							</v-row>
						</div>
					</div>

					<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
						<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
						添付ファイルを追加
						<input
							type="file"
							class="d-none"
							ref="uploadFile"
							@change="addFiles($event)"
							multiple
						/>
					</v-btn>

					<div class="file-area mt-2">
						<span v-if="allFiles < 1" class="filename">選択されていません</span>
						<template v-else>
							<v-chip
								class="ma-1 mt-2"
								close
								label
								outlined
								color="primary"
								@click:close="removeFile(i)"
								v-for="(file, i) in files"
								:key="file.name"
							>
								<v-icon class="mr-1">mdi-paperclip</v-icon>
								{{ file.name }}
							</v-chip>
						</template>
					</div>

					<v-divider class="my-2"></v-divider>
				</v-form>
				<div class="mail-area pa-2">
					<v-tabs v-model="orderedTab">
						<v-tabs-slider color="primary"></v-tabs-slider>

						<v-tab v-for="(supplier, index) in selectedSuppliers" :key="index">
							{{ supplier.name }}
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="orderedTab">
						<v-tab-item v-for="(supplier, index) in selectedSuppliers" :key="index">
							<div class="mt-4">
								<MailForm
									:key="index"
									:mailAddress="supplier.email"
									:mailInfo="supplier.mail_info"
								/>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</template>

			<!-- ここから未受注製品 -->
			<template v-if="quotationType == 'yet'">
				<v-form class="pa-2" ref="form2">
					<v-row no-gutters>
						<v-col cols="12" sm="6">
							<v-select
								v-model="selectedSuppliers"
								label="見積依頼先(必須)"
								:items="suppliers"
								class="mt-2"
								item-text="name"
								item-value="value"
								dense
								outlined
								multiple
								small-chips
								return-object
								hide-details="auto"
								@change="setYetMailContent"
							/>
						</v-col>
					</v-row>

					<v-text-field
						:ref="`matter_product_text_field`"
						v-model="matterProduct"
						class="mt-4"
						:hint="matterProductHint"
						label="製品検索(必須)"
						:persistent-hint="!!selectedMatterProduct"
						outlined
						dense
						:disabled="selectedSuppliers.length == 0 || !!selectedMatterProduct"
						:readonly="!!selectedMatterProduct"
						:class="{ 'custom-disabled-text-color': !!selectedMatterProduct }"
						@keyup="setSearchMatterProduct($event)"
						@change="changeMatterProduct"
					>
						<template v-if="selectedMatterProduct" v-slot:append>
							<v-btn @click="removeMatterProduct()" icon small>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</template>
					</v-text-field>

					<MatterProductSearchResult
						v-if="matterProductResultFlag"
						:matter_products="matter_products"
						:options="matter_product_options"
						@set-matter-product="setMatterProduct($event)"
					/>
					<v-row no-gutters>
						<v-col cols="12" sm="6">
							<v-row no-gutters class="flex-nowrap">
								<v-autocomplete
									:ref="`component_combobox`"
									v-model="selectedComponent"
									class="mt-2 mr-1"
									:items="components"
									:hint="componentHint"
									label="部品検索(必須)"
									outlined
									dense
									return-object
									item-text="component_name_and_part_number"
									item-value="id"
									:disabled="selectedSuppliers.length == 0"
									:no-data-text="componentHint"
									@keyup="setSearchComponent"
								/>
								<v-btn
									:disabled="!selectedComponent"
									@click="addComponent"
									class="mt-2"
									dense
									outlined
									color="secondary"
								>
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-row>
						</v-col>
					</v-row>

					<div>
						<v-row
							class="search-area top-divider"
							no-gutters
							v-for="(field, index) in ComponentQuantityFields"
							align="center"
							:key="index"
						>
							<v-col cols="12" sm="6">
								<v-row no-gutters>
									<v-col cols="12" sm="1">
										<v-row no-gutters justify="space-between">
											{{ `${index + 1}.` }}
											<v-btn
												v-if="$vuetify.breakpoint.xs"
												@click="removeField(field.value)"
												icon
												color="red"
												class="mt-0"
												><v-icon>mdi-close-circle-outline</v-icon></v-btn
											>
										</v-row>
									</v-col>
									<v-col cols="12" sm="11">
										<p v-if="field.value.component" class="pb-4">
											部品名：{{ field.value.component.name }}　　品番：{{
												field.value.component.part_number
											}}
										</p>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="field.value.quantity"
									class="mt-2 append-outer"
									label="数量(必須)"
									outlined
									dense
									:disabled="selectedSuppliers.length == 0"
									@change="changeComponent(field.value.component)"
								>
									<template v-if="!$vuetify.breakpoint.xs" v-slot:append-outer>
										<v-btn @click="removeField(field.value, index)" icon color="red" class="mt-0"
											><v-icon>mdi-close-circle-outline</v-icon></v-btn
										>
									</template>
								</v-text-field>
							</v-col>
						</v-row>
					</div>

					<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
						<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
						添付ファイルを追加
						<input
							type="file"
							class="d-none"
							ref="uploadFile"
							@change="addFiles($event)"
							multiple
						/>
					</v-btn>

					<div class="file-area mt-2">
						<span v-if="allFiles < 1" class="filename">選択されていません</span>
						<template v-else>
							<v-chip
								class="ma-1 mt-2"
								close
								label
								outlined
								color="primary"
								@click:close="removeFile(i)"
								v-for="(file, i) in files"
								:key="file.name"
							>
								<v-icon class="mr-1">mdi-paperclip</v-icon>
								{{ file.name }}
							</v-chip>
						</template>
					</div>
					<v-divider class="my-2"></v-divider>
				</v-form>
				<div class="mail-area pa-2">
					<v-tabs v-model="yetTab">
						<v-tabs-slider color="primary"></v-tabs-slider>

						<v-tab v-for="(supplier, index) in selectedSuppliers" :key="index">
							{{ supplier.name }}
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="yetTab">
						<v-tab-item v-for="(supplier, index) in selectedSuppliers" :key="index">
							<div class="mt-4">
								<MailForm
									:key="index"
									:mailAddress="supplier.email"
									:mailInfo="supplier.mail_info"
								/>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</template>
			<v-row class="ma-0 pa-0" justify="center">
				<v-btn
					class="ma-1 white--text font-weight-bold"
					@click="openConfirmationDialog"
					dense
					color="secondary"
					:disabled="!disabled"
				>
					<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
					作成する</v-btn
				>
			</v-row>
			<ConfirmationDialog
				:dialog.sync="confirmationDialog"
				:confirm_options="confirm_options"
				@accept="createComponentQuotes"
				@cancel="confirmationDialog = false"
			/>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import OrderedProductSearchResult from "./components/OrderedProductSearchResult.vue"
import ConfirmationDialog from "../shared/ConfirmationDialog.vue"
import MailForm from "./components/MailForm.vue"
import MatterProductSearchResult from "./components/MatterProductSearchResult.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		OrderedProductSearchResult,
		ConfirmationDialog,
		MailForm,
		MatterProductSearchResult,
	},
	data() {
		return {
			rules,
			common,
			title: "部品見積依頼作成",
			orderComponent: null,
			searchTimer: null,
			keyword: null,
			errorFlag: false,
			ordered_products: [],
			orderedProductResultFlag: false,
			selectComponentFlag: false,
			confirmationDialog: false,
			suppliers: [],
			selectedSuppliers: [],
			quote_request: {
				supplier_id: "",
				status_type: "sent",
				quote_type: "parts",
			},
			user: null,
			options: {
				isEmpty: null,
			},
			component_form_options: {
				items: [],
				selectedComponents: [],
				ordered_product: null,
			},
			files: [],
			removefiles: [],
			confirm_options: {
				description:
					"メールはこのまま送信され、この内容で見積データを作成します。\n本当によろしいですか？",
				accept_text: "メールを送信する",
				cancel_text: "キャンセル",
			},
			components: [],
			text: [],
			matterProduct: null,
			matter_products: [],
			matter_product_keyword: null,
			searchMatterProductTimer: null,
			matterProductErrorFlag: false,
			component: null,
			component_keyword: null,
			searchComponentTimer: null,
			componentErrorFlag: false,
			selectFormTypeDialogFlag: false,
			matterProductResultFlag: false,
			matter_product_options: {
				isEmpty: null,
			},
			component_texts: [],
			quotationType: null,
			matter_product_mail_texts: [],
			component_mail_texts: [],
			selectedOrderedProduct: null,
			selectedMatterProduct: null,
			selectedComponent: null,
			selectedOrderComponentCards: [],
			ComponentQuantityFields: [],
			quantityFields: [],
			matterProductTextFieldFlag: true,
			orderedProduct: null,
			orderedProductErrorFlag: false,
			ordered_product_keyword: null,
			searchOrderedProductTimer: null,
			orderComponents: [],
			quantityFieldFlag: false,
			orderedProductCardFlag: false,
			orderComponentArray: [],
			orderedProductCardTexts: [],
			orderedProductDisabled: false,
			orderedTab: null,
			yetTab: null,
		}
	},
	mounted() {
		this.fetchComponentQuotes()
	},
	methods: {
		removeField(field) {
			// 個別個数フィールド削除
			this.ComponentQuantityFields = this.ComponentQuantityFields.filter((quantityField) => {
				return quantityField.value.field_id !== field.field_id
			})
		},
		removeQuantityField(order_component, index) {
			// 個別個数フィールド削除
			this.quantityFields = this.quantityFields.filter((quantityField) => {
				return quantityField.value.field_id !== order_component.field_id
			})
		},
		setOrderComponent() {
			// 同じ部品のfieldは追加しない
			this.orderComponentArray.forEach((order_component) => {
				if (this.quantityFields.length) {
					const found = this.quantityFields.find((field) => {
						return field.value.component.id === order_component.component.id
					})
					if (!found) {
						let quantityField = {
							value: {
								field_id: this.newUuid(),
								component: order_component.component,
								order_component_id: order_component.id,
								quantity: order_component.quantity,
							},
						}
						this.quantityFields.push(quantityField)
					}
				} else {
					let quantityField = {
						value: {
							field_id: this.newUuid(),
							component: order_component.component,
							order_component_id: order_component.id,
							quantity: order_component.quantity,
						},
					}
					this.quantityFields.push(quantityField)
				}
			})
			this.orderComponentArray = []
		},
		newUuid() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
			)
		},
		changeFormType() {
			if (this.$refs.form1) {
				this.ordered_products = []
				this.$refs.form1.reset()
				this.selectedOrderedProduct = null
				this.quantityFields = []
				// this.removeCard()
			}
			if (this.$refs.form2) {
				this.$refs.form2.reset()
				this.matter_products = []
				this.removeMatterProduct()
				this.ComponentQuantityFields = []
			}
		},
		addComponent() {
			// 同じ部品のfieldは追加しない
			const component = this.selectedComponent
			const isComponentExist = this.ComponentQuantityFields.some((field) => {
				return field.value.component.id === component.id
			})

			if (!isComponentExist) {
				let field = {
					value: {
						field_id: this.newUuid(),
						component: this.selectedComponent,
						quantity: 0,
					},
				}
				this.ComponentQuantityFields.push(field)
			}

			this.selectedComponent = null
		},
		setMatterProduct(matter_product) {
			// カードテキストセット
			this.selectedMatterProduct = matter_product
			this.matterProduct = `製品名: ${matter_product.product.name} `
			this.matter_products = [] // 製品検索結果をリセット
			this.matter_product_keyword = "" // 製品検索キーワードをリセット

			let shallow_text = [...this.text]
			this.matter_product_mail_texts.forEach((matter_product_text) =>
				shallow_text.splice(7, 0, matter_product_text)
			)
			this.mailInfo.content = shallow_text.join("")
			this.matterProductResultFlag = false
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		removeFile(index) {
			const removeFile = this.files[index]
			this.files.splice(index, 1)
			this.removefiles.push(removeFile)
		},
		removeCard() {
			this.mailInfo.content = this.text.join("") //メールテキストを初期化
			this.quantityFields = [] // 個数フィールドを初期化し、１つ追加
			this.quantityFieldFlag = false // 個数フィールド非表示

			this.orderComponentArray = [] // 選択部品を初期化
			this.orderComponents = [] // 部品検索結果を初期化
			this.orderedProductCardTexts = [] // 製品カードテキストを初期化
			this.orderedProductCardFlag = false //カード非表示
			this.selectedOrderedProduct = null // 選択製品を初期化
			this.orderedProduct = null // 製品検索結果を初期化
		},
		removeMatterProduct() {
			this.matterProductTextFieldFlag = true
			// カードとメール文章リセット
			this.selectedMatterProduct = null
			this.$refs.form2.reset()
			this.mailInfo.content = this.text.join("")
			this.ComponentQuantityFields = []
			this.setMailTitle()
		},
		fetchComponentQuotes() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/component_quotes/new", {
					headers,
				})
				.then((res) => {
					this.suppliers = res.data.suppliers
					this.user = res.data.user
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setOrderedProduct(ordered_product) {
			this.orderComponents = ordered_product.order_components // 部品選択のitemsをセット
			this.ordered_products = [] // 製品検索結果をリセット
			this.orderComponentArray = [] //選択部品をリセット
			this.ordered_product_keyword = "" // 製品検索キーワードをリセット
			// カードから部品を削除
			this.quantityFields = []
			this.selectedOrderedProduct = ordered_product
			this.orderedProduct = `製造番号: ${ordered_product.product_number} 製品名: ${ordered_product.product.name}`
			this.setOrderedProductCard()
			this.orderedProductResultFlag = false
		},
		setOrderedMailContent() {
			this.selectedSuppliers.forEach((selectedSupplier) => {
				this.$set(selectedSupplier, "mail_info", { title: null, content: null, to: null, cc: null })

				if (selectedSupplier.email) {
					this.text = []
					this.text.push(
						`${selectedSupplier.name}\n`,
						`${selectedSupplier.pic_name}様\n`,
						"いつもお世話になっております。\n",
						`極東ゴムの${this.user.last_name}です。\n`,
						"以下の条件にて、お見積りをお願い致します。\n",
						"\n",
						"【お見積内容】\n",
						"\n以上、何卒よろしくお願いいたします。\n",
						"極東ゴム株式会社\n",
						`${this.user.full_name}`
					)
					let shallow_text = [...this.text]
					let component_mail_text = ""
					if (this.quantityFields.length) {
						this.quantityFields.forEach((field) => {
							if (field.value.component) {
								component_mail_text +=
									`部品名: ${field.value.component.name}\n` + `数量: ${field.value.quantity}\n`
							}
						})
						shallow_text.splice(7, 0, component_mail_text)
					}

					selectedSupplier.mail_info.content = shallow_text.join("")
					selectedSupplier.mail_info.to = selectedSupplier.email
				} else {
					this.text.push("メールアドレスが登録されていません")
					selectedSupplier.mail_info.content = this.text.join("")
				}
				const date = moment(Date.now())
				const title = "お見積のお願い" + "(" + this.formatDate(date) + ")"
				selectedSupplier.mail_info.title = title
			})
		},
		setYetMailContent() {
			this.selectedSuppliers.forEach((selectedSupplier) => {
				this.$set(selectedSupplier, "mail_info", { title: null, content: null, to: null, cc: null })

				if (selectedSupplier.email) {
					this.text = []
					this.text.push(
						`${selectedSupplier.name}\n`,
						`${selectedSupplier.pic_name}様\n`,
						"いつもお世話になっております。\n",
						`極東ゴムの${this.user.last_name}です。\n`,
						"以下の条件にて、お見積りをお願い致します。\n",
						"\n",
						"【お見積内容】\n",
						"\n以上、何卒よろしくお願いいたします。\n",
						"極東ゴム株式会社\n",
						`${this.user.full_name}`
					)
					let shallow_text = [...this.text]
					let component_mail_text = ""
					if (this.ComponentQuantityFields.length) {
						this.ComponentQuantityFields.forEach((field) => {
							if (field.value.component) {
								component_mail_text +=
									`部品名: ${field.value.component.name}\n` + `数量: ${field.value.quantity}\n`
							}
						})
						shallow_text.splice(7, 0, component_mail_text)
					}

					selectedSupplier.mail_info.content = shallow_text.join("")
					selectedSupplier.mail_info.to = selectedSupplier.email
				} else {
					this.text.push("メールアドレスが登録されていません")
					selectedSupplier.mail_info.content = this.text.join("")
				}
				const date = moment(Date.now())
				const title = "お見積のお願い" + "(" + this.formatDate(date) + ")"
				selectedSupplier.mail_info.title = title
			})
		},
		setMailTitle() {
			const date = moment(Date.now())
			const title = "お見積のお願い" + "(" + this.formatDate(date) + ")"
			this.mailInfo.title = title
		},
		setSearchMatterProduct(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.matter_product_options.isEmpty = false
			this.matter_products = []
			this.matter_product_keyword = e.target.value
			clearTimeout(this.searchMatterProductTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.matter_product_keyword.length) return // 0文字の場合はreturn
			this.searchMatterProductTimer = setTimeout(this.searchMatterProducts, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
			this.setMatterProductCard()
		},
		setSearchOrderedProduct(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.ordered_products = []
			this.ordered_product_keyword = e.target.value
			clearTimeout(this.searchOrderedProductTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.ordered_product_keyword.length) return // 0文字の場合はreturn
			this.searchOrderedProductTimer = setTimeout(this.searchOrderComponent, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		setCard() {
			this.orderedProductResultFlag = true
		},
		setMatterProductCard() {
			this.matterProductResultFlag = true
		},
		setOrderedProductCard() {
			this.orderedProductCardFlag = true
			this.orderedProductCardTexts = [this.selectedOrderedProduct]
		},
		createComponentQuotes() {
			let formData = new FormData()

			const supplierData = this.selectedSuppliers.map((supplier) => {
				return {
					id: supplier.id,
					mail_info: {
						title: supplier.mail_info.title,
						content: supplier.mail_info.content,
						to: supplier.mail_info.to,
						cc: supplier.mail_info.cc,
					},
				}
			})
			const requestData = JSON.stringify({ suppliers: supplierData })

			formData.set("suppliers", requestData)
			formData.set("quote_requests[status_type]", this.quote_request.status_type)
			formData.set("quote_requests[quote_type]", this.quote_request.quote_type)
			formData.set("component_quotes[quotation_type]", this.quotationType)
			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"files" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}

			if (this.quotationType == "ordered") {
				formData.set("component_quotes[ordered_product_id]", this.selectedOrderedProduct.id)
				this.quantityFields.forEach((field) => {
					formData.append("order_component_ids" + "[]", field.value.order_component_id)
				})
			}

			if (this.quotationType == "yet") {
				this.ComponentQuantityFields.forEach((field, index) => {
					let component = JSON.stringify({
						id: field.value.component.id,
						quantity: field.value.quantity,
					})
					formData.append("components" + "[]", component)
				})
				formData.set("component_quotes[matter_product_id]", this.selectedMatterProduct.id)
			}

			const headers = authenticate.setHeader()
			axios
				.post("/erp/v1/component_quotes", formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "部品見積を作成しました。",
					})
					this.$router.push({
						name: "component_quotes_index",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => {
					this.confirmationDialog = false
				})
		},
		openConfirmationDialog() {
			this.confirmationDialog = true
		},
		searchOrderComponent() {
			const params = {
				q: {
					product_number_cont: this.ordered_product_keyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_order_components", {
					headers,
					params,
				})
				.then((res) => {
					this.ordered_products = res.data.ordered_products
					this.searchOrderedProductTimer = null
					this.orderedProductErrorFlag = false
					this.orderedProductResultFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeMatterProduct() {
			this.matterProductTextFieldFlag = false
			// テキスト追加時の削除
			if (!this.matter_products.includes(this.matterProduct)) {
				this.errorFlag = true
				this.matterProduct = null
				this.$refs.matter_product_text_field.reset()
			}
		},
		changeOrderedProduct() {
			// テキスト追加時の削除
			if (!this.ordered_products.includes(this.orderedProduct)) {
				this.orderedProductErrorFlag = true
				this.orderedProduct = null
				this.$refs.ordered_product_text_field.reset()
			}
		},
		formatDate(date) {
			if (!date) return ""
			return moment(date).format("YYYY年MM月DD日")
		},
		searchMatterProducts() {
			const params = {
				q: {
					matter_name_or_matter_quotation_number_or_product_name_or_product_number_cont:
						this.matter_product_keyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_matter_products", {
					headers,
					params,
				})
				.then((res) => {
					this.matter_products = res.data.matter_products
					this.searchMatterProductTimer = null
					this.matterProductErrorFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setSearchComponent(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.components = []
			this.component_keyword = e.target.value
			clearTimeout(this.searchComponentTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.component_keyword.length) return // 0文字の場合はreturn
			this.searchTimer = setTimeout(this.searchComponents, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchComponents() {
			const params = {
				q: {
					name_or_part_number_cont: this.component_keyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_components", {
					headers,
					params,
				})
				.then((res) => {
					this.components = res.data.components
					this.searchComponentTimer = null
					this.componentErrorFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeComponent(component, field, index) {
			if (!component) return
			this.component = component

			// テキスト追加時の削除x
			if (!this.components.includes(this.component)) {
				this.componentErrorFlag = true
				this.$refs.component_combobox.reset()
			}
		},
		orderedValid() {
			const allSuppliersHaveMailInfo = this.selectedSuppliers.every((supplier) => {
				return (
					common.isPresence(supplier.mail_info.title) &&
					common.isPresence(supplier.mail_info.content)
				)
			})
			return (
				allSuppliersHaveMailInfo &&
				this.selectedSuppliers.length &&
				common.isPresence(this.selectedOrderedProduct) &&
				this.quantityFields.length
			)
		},
		yetValid() {
			const allSuppliersHaveMailInfo = this.selectedSuppliers.every((supplier) => {
				return (
					common.isPresence(supplier.mail_info.title) &&
					common.isPresence(supplier.mail_info.content)
				)
			})
			return (
				allSuppliersHaveMailInfo &&
				this.selectedSuppliers.length &&
				common.isPresence(this.selectedMatterProduct) &&
				this.ComponentQuantityFields.length
			)
		},
		multipleComponentCardText(card) {
			let text = ""

			let card_info = this.selectedOrderComponentCards.filter((order_component_card) => {
				return order_component_card.ordered_product.id == card.ordered_product.id
			})

			text = "製造番号:" + card_info[0].ordered_product.product_number + "\n"
			card_info[0].component_array.forEach((order_component) => {
				text +=
					`部品名: ${order_component.component.name}\n` +
					`品番: ${order_component.component.part_number}\n` +
					`数量: ${order_component.quantity}\n`
			})
			return text
		},
	},
	computed: {
		componentHint() {
			if (this.components.length) {
				return "部品を選択してください"
			} else if (this.searchComponentTimer) {
				return "部品を取得しています"
			} else if (!this.matter_products.length && this.component_keyword) {
				return "該当する部品が存在していません"
			} else if (this.componentErrorFlag && !this.component_keyword) {
				return "選択肢から部品を選択してください"
			} else if (this.selectedComponent) {
				return "選択後に右の＋ボタンを押してください"
			} else {
				return "部品名、または、品番を入力してください"
			}
		},
		matterProductHint() {
			if (this.matter_products.length) {
				return "製品を選択してください"
			} else if (this.searchMatterProductTimer) {
				return "製品を取得しています"
			} else if (!this.matter_products.length && this.matter_product_keyword) {
				return "該当する製品が存在していません"
			} else if (this.matterProductErrorFlag && !this.matter_product_keyword) {
				return "選択肢から製品を選択してください"
			} else if (this.selectedMatterProduct) {
				return "選択された製品のリセットは右の×ボタンで行えます"
			} else {
				return "案件名・見積番号・製品番号・製品名から検索できます"
			}
		},
		orderedProductHint() {
			if (this.ordered_products.length) {
				return "製品を選択してください"
			} else if (this.searchOrderedProductTimer) {
				return "製品を取得しています"
			} else if (!this.ordered_products.length && this.ordered_product_keyword) {
				return "該当する製品が存在していません"
			} else if (this.orderedProductErrorFlag && !this.ordered_product_keyword) {
				return "選択肢から製品を選択してください"
			} else if (this.selectedOrderedProduct) {
				return "選択された製品のリセットは右の×ボタンで行えます"
			} else {
				return "製造番号を入力してください"
			}
		},
		disabled() {
			if (this.quotationType == "ordered") {
				return this.orderedValid()
			} else {
				return this.yetValid()
			}
		},
		allFiles() {
			if (this.files) {
				return this.files.length
			}
		},
	},
	watch: {
		quantityFields: {
			deep: true,
			handler(newValue, oldValue) {
				// メールテキストセット
				this.selectedSuppliers.forEach((supplier) => {
					let shallow_text = [...this.text]
					let order_component_mail_text = ""
					this.quantityFields.forEach((field) => {
						if (field.value.component) {
							order_component_mail_text +=
								`部品名: ${field.value.component.name}\n` + `数量: ${field.value.quantity}\n`
						}
					})
					shallow_text.splice(0, 1, `${supplier.name}\n`)
					shallow_text.splice(7, 0, order_component_mail_text)

					supplier.mail_info.content = shallow_text.join("")
				})
			},
		},
		ComponentQuantityFields: {
			deep: true,
			handler(newValue, oldValue) {
				// メールテキストセット
				this.selectedSuppliers.forEach((supplier) => {
					let shallow_text = [...this.text]
					let order_component_mail_text = ""
					this.ComponentQuantityFields.forEach((field) => {
						if (field.value.component) {
							order_component_mail_text +=
								`部品名: ${field.value.component.name}\n` + `数量: ${field.value.quantity}\n`
						}
					})
					shallow_text.splice(0, 1, `${supplier.name}\n`)
					shallow_text.splice(7, 0, order_component_mail_text)

					supplier.mail_info.content = shallow_text.join("")
				})
			},
		},
	},
}
</script>

<style lang="scss">
@import "../../stylesheet/global.scss";
</style>
